import { render } from "./ObligationView.vue?vue&type=template&id=2a0dc51a"
import script from "./ObligationView.vue?vue&type=script&lang=js"
export * from "./ObligationView.vue?vue&type=script&lang=js"

import "./ObligationView.vue?vue&type=style&index=0&id=2a0dc51a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__